import { useState } from 'react'
import Button, { ButtonProps } from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'

export type ButtonColor = 'primary' | 'success' | 'warning' | 'danger' | 'text' | 'accent'

// Callers still pass EUI color names; translate until they migrate
const MUI_BUTTON_COLOR: Record<ButtonColor, ButtonProps['color']> = {
	primary: 'primary',
	success: 'success',
	warning: 'warning',
	danger: 'error',
	text: 'inherit',
	accent: 'secondary',
}

export type ConfirmModalProps = {
	onCancel: () => void,
	onConfirm: () => Promise<any>,
	onSuccess: () => void,
	message: string,
	buttonText: string,
	buttonColor?: ButtonColor,
}
export default function ConfirmModal( { onCancel, onConfirm, onSuccess, message, buttonText, buttonColor = 'primary' }: ConfirmModalProps ) {
	const [ isSaving, setIsSaving ] = useState( false )
	const handleConfirmClick = async() => {
		setIsSaving( true )
		try {
			await onConfirm()
		} catch {
			// The Apollo error link has already toasted the failure; stay open so the user can retry
			setIsSaving( false )
			return
		}
		setIsSaving( false )
		onSuccess()
	}
	return (
		<>
			<DialogContent>
				<DialogContentText>
					{message}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					id="cancelBtn"
					color="inherit"
					onClick={onCancel}
				>
					Cancel
				</Button>
				<Button
					id="confirmBtn"
					variant="contained"
					color={MUI_BUTTON_COLOR[ buttonColor ]}
					onClick={handleConfirmClick}
					loading={isSaving}
				>
					{buttonText}
				</Button>
			</DialogActions>
		</>
	)
}
